import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import * as z from "zod";

export const getEmailTemplates = {
  name: "getEmailTemplates" as const,
  input: z.object({}),
  output: z.array(emailTemplateSchema),
};
